import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import CustomText from '@/features/ui/form/CustomText';
import CustomRow from '@/features/ui/layout/CustomRow';
import { useContentsModal } from '@/hooks/useContentsModal';
import { SecureStorage } from '@/plugin/crypto';
import { statisticsQueryKey } from '@/queries/_querykey';
import { postMutation } from '@/queries/_utils';
import { alertIdState } from '@/state/alert';

export default function AlertInfo() {
	const secureStorage = new SecureStorage(sessionStorage);
	const userInfo = secureStorage.getItem('user-storage', 'user-storage');
	const { member_flag: memberFlag } = userInfo;
	const initialAlertInfo = {
		alertDevicetype: '',
		alertType: '',
		alertMac: '',
		alertName: '',
		alertLine: '',
		alertStation: '',
		alertSimpaddr: '',
		alertSerial: '',
		alertPhone: '',
		alertDate: '',
	};

	const id = useRecoilValue(alertIdState);
	const { closeContentModal } = useContentsModal();

	const [alertInfo, setAlertInfo] = useState(initialAlertInfo);

	const updateMutation = useMutation({
		mutationFn: () => postMutation([...statisticsQueryKey.alertDetail(), null, { alertNo: id }]),
		onSuccess: (data) => {
			const alertInfo = {
				alertDevicetype: data.alertDevicetype,
				alertType: data.alertType,
				alertMac: data.alertMac,
				alertName: data.alertName,
				alertLine: data.alertLine,
				alertStation: data.alertStation,
				alertSimpaddr: data.alertSimpaddr,
				alertSerial: data.alertSerial,
				alertPhone: data.alertPhone,
				alertDate: data.alertDate,
			};
			setAlertInfo(alertInfo);
		},
	});

	const handleChangeAlertInfo = (name: string, value: string | number) => {
		setAlertInfo((prev) => {
			return { ...prev, [name]: value };
		});
	};

	const handleModalClose = () => {
		setAlertInfo(initialAlertInfo);
		closeContentModal();
	};

	useEffect(() => {
		if (id) updateMutation.mutate();
		else setAlertInfo(initialAlertInfo);
	}, [id]);

	return (
		<>
			<div className="modal-header">
				<h4 className="modal-title">알림 정보</h4>
			</div>
			<div className="form-info form-info-vertical px-2" style={{ maxWidth: '900px', width: '90vw' }}>
				<div className="modal-body">
					<CustomRow>
						<div className="form-grid">
							<CustomText labelTitle="호선" text={alertInfo.alertLine} />
						</div>
						<div className="form-grid">
							<CustomText labelTitle="역사명" text={alertInfo.alertStation} />
						</div>
					</CustomRow>
					<CustomRow>
						<div className="form-grid">
							<CustomText labelTitle="세부설치위치" text={alertInfo.alertSimpaddr} />
						</div>
						<div className="form-grid">
							<CustomText labelTitle="알림유형" text={alertInfo.alertType} />
						</div>
					</CustomRow>
					<CustomRow>
						<div className="form-grid">
							<CustomText labelTitle="라우터" text={alertInfo.alertSerial} />
						</div>
						<div className="form-grid">
							<CustomText labelTitle="전화번호" text={alertInfo.alertPhone} />
						</div>
					</CustomRow>
					<CustomRow>
						{memberFlag === 1 && (
							<div className="form-grid">
								<CustomText labelTitle="MAC" text={alertInfo.alertMac} />
							</div>
						)}
						<div className="form-grid">
							<CustomText labelTitle="알림일시" text={alertInfo.alertDate} />
						</div>
					</CustomRow>
				</div>
				<div className="modal-footer">
					<button type="button" className="btn btn-default" onClick={handleModalClose}>
						닫기
					</button>
				</div>
			</div>
		</>
	);
}
